import { graphql } from '@/gql';
import type { CancelScheduledRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelScheduledRide = async ({
  scheduledRideId,
  cancellationReason,
  canceledByType,
  isReschedule,
}: CancelScheduledRideMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CancelScheduledRide(
        $scheduledRideId: Float!
        $cancellationReason: String!
        $canceledByType: CanceledByType!
        $isReschedule: Boolean
      ) {
        cancelScheduledRide(
          scheduledRideId: $scheduledRideId
          cancellationReason: $cancellationReason
          canceledByType: $canceledByType
          isReschedule: $isReschedule
        ) {
          id
        }
      }
    `),
    variables: {
      scheduledRideId,
      cancellationReason,
      canceledByType,
      isReschedule,
    },
  });

  return !!response.data?.cancelScheduledRide;
};
